export enum RestrictedValueEnum {
  NONE = 'none',
  WRITE = 'write',
  READ = 'read',
}
